"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepClone = void 0;
/**
 * This should be sufficient as long as it is only used on JSON-supported objects
 * (which should be the case in this project, as we're mostly cloning states to avoid side-effects).
 * Use caution if you start dealing with objects/values not supported by JSON,
 * notably (but not exclusively) Maps, Sets, Blobs, NaN/Infinity, ...
 **/
var deepClone = function (obj) { return JSON.parse(JSON.stringify(obj)); };
exports.deepClone = deepClone;
//# sourceMappingURL=deepClone.js.map